import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Purple_Btn from "../../../../common_components/common_btn/purple_btn/Purple_Btn";
import Address_cards from "../../../../common_components/address_cards/Address_cards";

import { faPenToSquare, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UserGet } from "../../../../../utils/apis/myAccount/myAccount";
import { getAddress } from "../../../../../utils/apis/orderProcess/orderProcess";

function Step1_Account({
  shippingAddrress,
  setShippingAddress,
  billingAddrress,
  goToStep,
  setBillingAddress,
  setSameShippingAddress,
  sameShippingAddress,
  user
}) {
 

  const [address, setAddress] = useState();

  const getAllData = async () => {
    const res = await getAddress();
    if (res?.success) {
      setAddress(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);
  const [error, setError] = useState("");
  const handelnext = (step) => {
    if (!billingAddrress) {
      setError("Address required");
      return;
    }

    goToStep(step);
  };
  return (
    <>
      <div className="content_box_holder mt-3">
        <div className="heading_strip_holder">
          <div className="content_strip_holder">
            <div>
              <h1>Account</h1>
            </div>
          </div>
          <hr />
        </div>

        <div className="content_strip_holder">
          <p>{user?.email}</p>
          {/* <FontAwesomeIcon icon={faPenToSquare} /> */}
        </div>
      </div>

      <div className="content_box_holder mt-3">
        <div className="content_strip_holder">
          <Form.Group controlId="formBasicCheckbox">
            <Form.Check
              type="checkbox"
              label="Is shipping address same as billing address"
              disabled={!billingAddrress}
              checked={sameShippingAddress}
              onChange={(e) => {
                setSameShippingAddress(e.target.checked);
                setShippingAddress(billingAddrress);
              }}
            />
          </Form.Group>

          {/* <div className="delete_btn_holder">
            <FontAwesomeIcon icon={faTrashCan} />
          </div> */}
        </div>

        <div className="address_cards_holder">
          <div className="row">
            {address?.map((val) => (
              <div className="col-md-6">
                <Address_cards
                  billingAddrress={billingAddrress}
                  setError={setError}
                  value={val}
                  setBillingAddress={setBillingAddress}
                />
              </div>
            ))}
          </div>
        </div>
        {error && <span className="text-danger">{error}</span>}
        <div className="btn_holder">
          <Purple_Btn btnText="Add New Address" onClick={() => goToStep(4)} />

          <div
            onClick={() => {
              if (!sameShippingAddress) {
                handelnext(5);
              } else {
                handelnext(2);
              }
            }}
          >
            <Purple_Btn btnText="Continue" />
          </div>
        </div>
      </div>

      {/* <div className="content_box_holder mt-3">
        <div className="heading_strip_holder">
          <div className="content_strip_holder">
            <h1>Payment</h1>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default Step1_Account;
